import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropDownComponent implements OnInit {
  @Input() options: Array<any>;
  @Input() title: any;
  @Input() parentForm: FormGroup;
  @Input() parentControl: string;
  @Input() showAll: boolean;
  @Input() isZeroAllowed: boolean;
  @Input() isDisabled: boolean;
  isDropDown: boolean;
  activeTitle: any;

  @Output() readonly selectedOption: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.activeTitle = this.title;
  }

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  trackByFunction(index): number {
    return index;
  }

  get f() {
    return this.parentForm.controls;
  }
}
